import { Button, Input, Row, Form, Grid, SelectForm } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { Control } from 'react-hook-form'
import { SPACING } from 'utils'
import { SearchSupplierRegistrationProps } from '../../SearchSupplierRegistration'

interface FiltersProps {
  control: Control<SearchSupplierRegistrationProps>
  handleSubmit: any
  handleSearchSupplier: (_form?: SearchSupplierRegistrationProps) => void
  handleClearFilters: () => void
  supplierType: string
}

export const FilterTableSupplier: React.FC<FiltersProps> = ({
  control,
  handleSearchSupplier,
  handleSubmit,
  handleClearFilters,
  supplierType
}) => {

  const personTypes = [
    { label: 'Todos', value: "T" },
    { label: 'Pessoa Jurídica', value: 'J' },
    { label: 'Pessoa Física', value: 'F' },
    { label: 'Estrangeiro', value: 'E' }
  ]

  function handleSubmitForm(form?: SearchSupplierRegistrationProps) {
    handleSearchSupplier(form)
  }

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid
        gridCols="1fr 1fr  1fr  3fr  2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          label="Código"
          placeholder="Cód."
          control={control}
          min={0}
          mask={["#########"]}
          defaultValue=''
          formValue='CdFornecedor'
        />

        <Input
          label="Código SAP"
          control={control}
          placeholder="Cód. SAP"
          maxLength={10}
          formValue='CdFornecedorSap'
        />

        <SelectForm
          listOptions={personTypes}
          control={control}
          label="Tipo"
          formValue='CdTipoFornecedor'
          placeholder="Selecione"
        />

        {supplierType === 'F' ? (
          <Input
            label="CPF"
            placeholder="CPF"
            formValue='CdDocto'
            control={control}
            mask={['###.###.###-##']}
          //maxLength={14}
          />
        ) : null}
        {supplierType === 'J' ? (
          <Input
            label="CNPJ"
            placeholder="CNPJ"
            formValue='CdDocto'
            control={control}
            mask={['##.###.###/####-##']}
          //maxLength={18}
          />
        ) : null}
        {supplierType === 'E' ? (
          <Input
            label="Cód.Fornecedor"
            placeholder="Cód.Fornecedor"
            formValue='CdDocto'
            control={control}
            mask={['############']}
          //maxLength={20}
          />
        ) : null}
        {supplierType === 'T' ? (
          <Input label="Documento" placeholder="Escolha um Tipo" disabled />
        ) : null}
        <Input
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue='NmFornecedor'
          control={control}
          maxLength={50}
        />
      </Grid>

      <Row
        alignItems="center"
        justifyContent="flex-end"
        marginTop={SPACING.spacing15}
      >
        <Button
          text="Limpar"
          onClick={handleClearFilters}
          variantButton="text"
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Button
          endIcon={<MagnifyingGlassIcon />}
          text="Pesquisar"
          type={'submit'}
          marginLeft={SPACING.spacing15}
        />
      </Row>
    </Form>
  )
}
